module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"dialog\" title=\"")
    ; __append(escapeFn( subtitle))
    ; __append("\"  >\r\n    <div id=\"filterListContainer\">\r\n        <input id=\"filterList\" type=\"text\" placeholder=\"Filter List...\" />\r\n    </div>\r\n    <div id=\"warn-users-max-shown\" style=\"display:none;font-style: italic;\"></div>\r\n    <ul class=\"select-list\" id=\"allListModal\">\r\n     \r\n    </ul>\r\n\r\n    <ul class=\"select-list\" id=\"filteredListModal\" style=\"display: none;\">\r\n     \r\n    </ul>\r\n\r\n</div>")
  }
  return __output;

}